// Il dominio pubblico resta distinto dall'host delle chiamate API in anteprima.
export const SITE_URL = new URL(process.env.REACT_APP_SITE_URL).origin;

export const canonicalUrl = (path = "/") => {
    const { pathname } = new URL(path, `${SITE_URL}/`);
    return `${SITE_URL}${pathname}`;
};

export const socialImageUrl = (image = "/og-image.png") => {
    const url = new URL(image, `${SITE_URL}/`);
    if (url.origin === new URL(process.env.REACT_APP_BACKEND_URL).origin) {
        return `${SITE_URL}${url.pathname}${url.search}`;
    }
    return url.href;
};